import { createFileRoute, Navigate } from "@tanstack/react-router";

/**
 * `/` is the console's way in, on every host. On the central host the Worker sends a browser with no session straight
 * to sign in (src/worker/index.ts), so whoever reaches this page has one: the console takes them on to their
 * workspaces, opening the only one directly, or, when the session has ended since, straight to sign in
 * (src/client/routes/admin.tsx). On a workspace's own host it is that workspace's console.
 */
export const Route = createFileRoute("/")({ component: () => <Navigate to="/admin" /> });
